import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';

const CounterChip = ({ count }) => (
  <Chip label={count} sx={{ backgroundColor: 'secondary.light', width: 25 }} variant="badge" />
);

CounterChip.propTypes = {
  count: PropTypes.number.isRequired,
};

export default CounterChip;
